<template>
  <nav>
    <router-link class="imageLink" to="/">
      <img alt="Vue logo" src="@/assets/EuroAviaBridge.png" />
    </router-link>
    <div class="menu-toggle" @click="toggleMenu">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </div>
    <div :class="{'menu-active': isMenuActive}" class="menu">
      <router-link
        v-for="link in navLinks"
        :key="link.path"
        :to="link.path"
        @click="handleLinkClick"
        class="nav-link"
      >
        {{ link.name }}
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavbarSection',
  data() {
    return {
      isMenuActive: false,
      navLinks: [ 
        { name: 'INFO', path: '/info' },
        { name: 'SCHEDULE', path: '/schedule' },
        { name: 'SPEAKERS', path: '/speakers' },
        { name: 'FEEDBACK', path: '/feedback' },
        { name: 'GALLERY', path: '/staytuned' }
      ],
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive;
    },
    handleLinkClick() {
      this.isMenuActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  padding: 10px 20px;
  margin: 30px;
  border-radius: 20px;
  position: sticky;
  top: 0;
  background-color: #f0f0f063;
  display: flex;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
  z-index: 3;
  align-items: center;
  
  .imageLink {
    padding: 0px;
    flex-grow: 0;
  }
  
  img {
    width: 60px;
    height: 60px;
  }
  
  .menu-toggle {
    display: none;
    flex-direction: column;
    cursor: pointer;
    margin-left: auto;
    padding-right: 15px;

    .bar {
      width: 25px;
      height: 3px;
      background-color: #335C85;
      margin: 3px 0;
      transition: all 0.3s ease;
    }
  }

  .menu {
    display: flex;
    flex-direction: row;
    margin-left: auto;
    width: 100%;
    
    .nav-link {
      flex: 1;
      font-weight: bold;
      color: #335C85;
      text-align: center;
      font-family: Calibri;
      text-decoration: none;
      font-size: 20px;
      border-radius: 10px;
      padding: 15px 0;
      margin: 0 5px;
      
      &.router-link-exact-active {
        color: #003366;
      }

      &:hover {
        background-color: #E6E6E6;
        box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.25);
      }
    }
  }


  @media (max-width: 768px) {
    padding: 5px;

    img {
      width: 50px;
      height: 50px;
    }

    .menu-toggle {
      display: flex;
    }

    .menu {
      display: none;
      flex-direction: column; 
      width: 100%; 
      background-color: #dddcdc;
      border-radius: 20px;
      position: absolute;
      top: 75px;
      left: 0;
      z-index: 2;

      &.menu-active {
        display: flex;
      }

      a {
        padding: 15px;
        text-align: left;
      }
    }
  }
}
</style>
